import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((themem) => ({
   
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: '8vw',
        justifyContent: 'space-between',
    }
}))